import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import Home from "./Pages/Home";
import AboutUs from "./Pages/AboutUs";
import Vision from "./Pages/Vision";
import OurMotto from "./Pages/OurMotto";
import OurSchool from "./Pages/OurSchool";
import Staff from "./Pages/Staff";
import Mission from "./Pages/Mission";
import SchoolFees from "./Pages/SchoolFees";
import Classroom from "./Pages/Classroom";
import OurHeavenlyPatron from "./Pages/OurHeavenlyPatron";
import FormerPrincipalMessage from "./Pages/FormerPrincipalMessage";
import ManagersMessage from "./Pages/ManagersMessage";
import PrincipalMessage from "./Pages/PrincipalMessage";
import LibraryRules from "./Pages/LibraryRules";
import Admission from "./Pages/Admission";
import BookList from "./Pages/BookList";
import Circular from "./Pages/Circular";
import CBSECircular from "./Pages/CBSECircular";
import SchoolTransportation from "./Pages/SchoolTransportation";
import CMCHistory from "./Pages/CMCHistory";
import Courses from "./Pages/Courses";
import Facilities from "./Pages/Facilities";
import ToTheParents from "./Pages/ToTheParents";
import CoCurriculum from "./Pages/CoCurriculum";
import Activities from "./Pages/Activities";
import SchoolUniform from "./Pages/SchoolUniform";
import OurUniqueness from "./Pages/OurUniqueness";
import Infrastructure from "./Pages/Infrastructure";
import StudentStrength from "./Pages/StudentStrength";
import RulesRegulation from "./Pages/RulesRegulation";
import SchoolTiming from "./Pages/SchoolTiming";
import CbseDisclosure from "./Pages/CbseDisclosure";
import ErpSoftware from "./Pages/ErpSoftware";
import Tc from "./Pages/Tc";
import ContactUs from "./Pages/ContactUs";
import LifeTags from "./Pages/LifeTags";
import ManagementCommittee from "./Pages/ManagementCommittee";
import CovidResponse from "./Pages/CovidResponse";
import VideoGallery from "./Pages/VideoGallery";
import AluminiAssociation from "./Pages/AluminiAssociation";
import Gallery from "./Pages/Gallery";
import PhotoGallery from "./Pages/PhotoGallery";
import SubPhotoGallery from "./Pages/SubPhotoGallery";
import OutReachProgram from "./Pages/OutReachProgram";
import SubOutReachProgram from "./Pages/SubOutReachProgram";
import EcoClub from "./Pages/EcoClub";
import SubEcoClub from "./Pages/SubEcoClub";
import Assemblies from "./Pages/Assemblies";
import SubAssemblies from "./Pages/SubAssemblies";
import Activity from "./Pages/Activity";
import SubActivity from "./Pages/SubActivity";
import CoCurricular from "./Pages/CoCurricular";
import SubCoCurricular from "./Pages/SubCoCurricular";
import Picnic from "./Pages/Picnic";
import SubPicnic from "./Pages/SubPicnic";
import CPD from "./Pages/CPD";
import SubCPD from "./Pages/SubCPD";
import Celebrations from "./Pages/Celebrations";
import SubCelebrations from "./Pages/SubCelebrations";
import ArtFest from "./Pages/ArtFest";
import SubArtFest from "./Pages/SubArtFest";
import Exhibition from "./Pages/Exhibition";
import SubExhibition from "./Pages/SubExhibition";
import News from "./Pages/News";
import ToppersX from "./Pages/ToppersX";
import NoticeBoard from "./Pages/NoticeBoard";
import Events from "./Pages/Events";
import GlimpseOfTheDay from "./Pages/GlimpseOfTheDay";
import ThoughtOfTheDay from "./Pages/ThoughtOfTheDay";
import WhatSetsUsApart from "./Pages/WhatSetsUsApart";
import PriPrimarySchool from "./Pages/PriPrimarySchool";
import PrimarySchool from "./Pages/PrimarySchool";
import SecondarySchool from "./Pages/SecondarySchool";
import SrSecondarySchool from "./Pages/SrSecondarySchool";
import MiddleSchool from "./Pages/MiddleSchool";
import Newsletter from "./Pages/Newsletter";
import EPublication from "./Pages/EPublication";
import HolidaysHomework from "./Pages/HolidaysHomework";
import Datesheet from "./Pages/Datesheet";
import AdmissionXI from "./Pages/AdmissionXI";
import Feestructure from "./Pages/Feestructure";
import Career from "./Pages/Career";
import Result from "./Pages/Result";
import EntranceExamination from "./Pages/EntranceExamination";
import EntranceExamClassXI from "./Pages/EntranceExamClassXI";
import SportActivities from "./Pages/SportActivities";
import JuniorWing from "./Pages/JuniorWing";
import Termone from "./Pages/Termone";
import Termtwo from "./Pages/Termtwo";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/BookList" element={<BookList />} />
          <Route path="/Admission" element={<Admission />} />
          <Route path="/Staff" element={<Staff />} />
          <Route path="/Circular" element={<Circular />} />
          <Route path="/CBSECircular" element={<CBSECircular />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/career" element={<Career></Career>}></Route>
          <Route path="/OurSchool" element={<OurSchool />} />
          <Route path="/Classroom" element={<Classroom />} />
          <Route path="/Courses" element={<Courses />} />
          <Route path="/SchoolFees" element={<SchoolFees />} />
          <Route path="/Mission" element={<Mission />} />
          <Route path="/CoCurriculum" element={<CoCurriculum />} />
          <Route path="/ToTheParents" element={<ToTheParents />} />
          <Route path="/Vision" element={<Vision />} />
          <Route path="/SchoolTiming" element={<SchoolTiming />} />
          <Route path="/OurMotto" element={<OurMotto />} />
          <Route path="/SchoolTransportation" element={<SchoolTransportation />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/CMCHistory" element={<CMCHistory />} />
          <Route path="/LibraryRules" element={<LibraryRules />} />
          <Route path="/Activities" element={<Activities />} />
          <Route path="/OurHeavenlyPatron" element={<OurHeavenlyPatron />} />
          <Route path="/SchoolUniform" element={<SchoolUniform />} />
          <Route path="/FormerPrincipalMessage" element={<FormerPrincipalMessage />} />
          <Route path="/ManagersMessage" element={<ManagersMessage />} />
          <Route path="/PrincipalMessage" element={<PrincipalMessage />} />
          <Route path="/Facilities" element={<Facilities />} />
          <Route path="/OurUniqueness" element={<OurUniqueness />} />
          <Route path="/Infrastructure" element={<Infrastructure />} />
          <Route path="/StudentStrength" element={<StudentStrength />} />
          <Route path="/RulesRegulation" element={<RulesRegulation />} />
          <Route path="/CbseDisclosure" element={<CbseDisclosure />} />
          <Route path="/ErpSoftware" element={<ErpSoftware />} />
          <Route path="/ManagementCommittee" element={<ManagementCommittee />} />
          <Route path="/Tc" element={<Tc />} />
          <Route path="/LifeTags" element={<LifeTags />} />
          <Route path="/CovidResponse" element={<CovidResponse />} />
          <Route path="/VideoGallery" element={<VideoGallery />} />
          <Route path="/AluminiAssociation" element={<AluminiAssociation />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Activity" element={<Activity />} />
          <Route path="/SubActivity" element={<SubActivity />} />
          <Route path="/OutReachProgram" element={<OutReachProgram />} />
          <Route path="/SubOutReachProgram" element={<SubOutReachProgram />} />
          <Route path="/EcoClub" element={<EcoClub />} />
          <Route path="/SubEcoClub" element={<SubEcoClub />} />
          <Route path="/Assemblies" element={<Assemblies />} />
          <Route path="/SubAssemblies" element={<SubAssemblies />} />
          <Route path="/CoCurricular" element={<CoCurricular />} />
          <Route path="/SubCoCurricular" element={<SubCoCurricular />} />
          <Route path="/Picnic" element={<Picnic />} />
          <Route path="/SubPicnic" element={<SubPicnic />} />
          <Route path="/CPD" element={<CPD />} />
          <Route path="/SubCPD" element={<SubCPD />} />
          <Route path="/Celebrations" element={<Celebrations />} />
          <Route path="/SubCelebrations" element={<SubCelebrations />} />
          <Route path="/ArtFest" element={<ArtFest />} />
          <Route path="/SubArtFest" element={<SubArtFest />} />
          <Route path="/Exhibition" element={<Exhibition />} />
          <Route path="/SubExhibition" element={<SubExhibition />} />
          <Route path="/PhotoGallery" element={<PhotoGallery />} />
          <Route path="/SubPhotoGallery" element={<SubPhotoGallery />} />
          <Route path="/SportActivities" element={<SportActivities />} />
          <Route path="/JuniorWing" element={<JuniorWing />} />
          <Route path="/ToppersX" element={<ToppersX />} />
          <Route path="/News" element={<News />} />
          <Route path="/NoticeBoard" element={<NoticeBoard />} />
          <Route path="/Events" element={<Events />} />
          <Route path="/GlimpseOfTheDay" element={<GlimpseOfTheDay />} />
          <Route path="/ThoughtOfTheDay" element={<ThoughtOfTheDay />} />
          <Route path="/WhatSetsUsApart" element={<WhatSetsUsApart />} />
          <Route path="/PriPrimarySchool" element={<PriPrimarySchool />} />
          <Route path="/PrimarySchool" element={<PrimarySchool />} />
          <Route path="/MiddleSchool" element={<MiddleSchool />} />
          <Route path="/SecondarySchool" element={<SecondarySchool />} />
          <Route path="/SrSecondarySchool" element={<SrSecondarySchool />} />
          <Route path="/Newsletter" element={<Newsletter />} />
          <Route path="/EPublication" element={<EPublication />} />
          <Route path="/HolidaysHomework" element={<HolidaysHomework />} />
          <Route path="/Datesheet" element={<Datesheet />} />
          <Route path="/AdmissionXI" element={<AdmissionXI />} />
          <Route path="/Feestructure" element={<Feestructure />} />
          <Route path="/Result" element={<Result />} />
          <Route path="/EntranceExamination" element={<EntranceExamination />} />
          <Route path="/EntranceExamClassXI" element={<EntranceExamClassXI />} />
          <Route path="/Termone" element={<Termone />} />
          <Route path="/Termtwo" element={<Termtwo />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
